import { render, staticRenderFns } from "./monitorPreview.vue?vue&type=template&id=8c40a554&scoped=true&"
import script from "./monitorPreview.vue?vue&type=script&lang=js&"
export * from "./monitorPreview.vue?vue&type=script&lang=js&"
import style0 from "./monitorPreview.vue?vue&type=style&index=0&id=8c40a554&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c40a554",
  null
  
)

export default component.exports